import { PresentationTreeResponse } from 'app/api/tag-queries/types';

export function pruneToUsedConcepts(data: PresentationTreeResponse | null | undefined, usedConceptNames: Set<string>): PresentationTreeResponse | null {
  if (!data) return null;
  if (!data.presentationTree) return data;

  const pruneNode = (node: any): any | null => {
    const prunedChildren = (node.children ?? []).map(pruneNode).filter((n: any) => n !== null);
    if (usedConceptNames.has(node.id) || prunedChildren.length > 0) {
      return { ...node, children: prunedChildren };
    }
    return null;
  };

  const networks = data.presentationTree.networks
    .map((network: any) => ({ ...network, roots: (network.roots ?? []).map(pruneNode).filter((r: any) => r !== null) }))
    .filter((network: any) => network.roots.length > 0);

  return { ...data, presentationTree: { ...data.presentationTree, networks } };
}
